"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRecaptchaGoogle = require("react-recaptcha-google");
var _global = _interopRequireDefault(require("global"));
var _FormWrap = _interopRequireDefault(require("../../../../Form/FormWrap"));
var _Input = _interopRequireDefault(require("../../../../Form/Input"));
var _TextArea = _interopRequireDefault(require("../../../../Form/TextArea"));
var _Select = _interopRequireDefault(require("../../../../Form/Select"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _Alert = _interopRequireDefault(require("../../../../Alert/Alert"));
var _ComponentWrapper = _interopRequireDefault(require("../../../../helpers/ComponentWrapper"));
var _constants = require("../../../../constants");
var _hooks = require("../../../../../helpers/hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TswContactUs = function TswContactUs() {
  var _useForm = (0, _hooks.useForm)({
      role: 'lead',
      lead_source: _constants.INTERCOM_LEAD_SOURCE.TSW_CONTACT_US
    }),
    formData = _useForm.formData,
    handleChange = _useForm.handleChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)({
      type: '',
      text: ''
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    notification = _useState4[0],
    setNotification = _useState4[1];
  var contactFormCaptcha = (0, _react.useRef)();
  var contactForm = (0, _react.useRef)();
  // we need this ref to store actual value of state because in verifyCallback
  // The callbacks will not be reactive - they will not re-run the instant state changes,
  // but they *will* see the current value whenever they do run
  var formDataRef = (0, _react.useRef)();
  formDataRef.current = formData;
  var onLoadRecaptcha = function onLoadRecaptcha(e) {
    if (e) {
      e.preventDefault();
      setLoading(true);
    }
    if (contactFormCaptcha && contactFormCaptcha.current) {
      contactFormCaptcha.current.reset();
      contactFormCaptcha.current.execute();
    }
  };
  function verifyCallback(recaptchaToken) {
    // Here you will get the final recaptchaToken!!!
    var _formDataRef$current = formDataRef.current,
      first_name = _formDataRef$current.first_name,
      last_name = _formDataRef$current.last_name,
      email = _formDataRef$current.email,
      preffered_travel_date = _formDataRef$current.preffered_travel_date,
      route_interest = _formDataRef$current.route_interest,
      additional_comments = _formDataRef$current.additional_comments,
      phone = _formDataRef$current.phone,
      role = _formDataRef$current.role,
      lead_source = _formDataRef$current.lead_source;
    var data = {
      role: role,
      name: "".concat(first_name, " ").concat(last_name),
      email: email,
      phone: phone
    };
    if (additional_comments) {
      data.custom_attributes = {
        additional_comments: additional_comments,
        lead_source: lead_source
      };
    }
    if (recaptchaToken) {
      fetch('/api/intercom-create-contact', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function () {
        setLoading(false);
        setNotification({
          type: 'success',
          text: 'Message successfully sent!'
        });
      })["catch"](function () {
        setLoading(false);
        setNotification({
          type: 'error',
          text: 'Something went wrong! Please try again later.'
        });
      });
    }
  }
  ;
  if (!!notification.text && notification.type === 'success') {
    return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
      className: "max-width-xxs"
    }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({}, notification, {
      show: true
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-xxs"
  }, /*#__PURE__*/_react["default"].createElement(_FormWrap["default"], {
    ref: contactForm,
    onSubmit: onLoadRecaptcha,
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: "First name",
    name: "first_name",
    id: "first_name",
    label: "First name",
    type: "text",
    value: formData.first_name,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: "Last name",
    name: "last_name",
    id: "last_name",
    label: "Last name",
    type: "text",
    value: formData.last_name,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    name: "email",
    type: "email",
    id: "email",
    placeholder: "Email",
    label: "Email",
    value: formData.email,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_TextArea["default"], {
    placeholder: "Anything else?",
    id: "additional_comments",
    name: "additional_comments",
    type: "text",
    label: "Leave your question",
    value: formData.additional_comments,
    onChange: handleChange,
    required: true
  }), !!notification.type && notification.type !== 'success' && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-y-md",
    type: "error",
    show: true,
    message: "Ooops! Something went wrong. Please try again later.",
    onClose: function onClose() {
      return setNotification({});
    }
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    text: loading ? 'Submitting...' : 'Submit',
    buttonType: _constants.BUTTON_TYPES.PRIMARY,
    buttonSize: "btn--md",
    className: "margin-bottom-md",
    fullWidth: true,
    disabled: loading
  }), /*#__PURE__*/_react["default"].createElement("small", {
    className: "d8-u-color-contrast-high"
  }, "This site is protected by reCAPTCHA and the Google", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://policies.google.com/privacy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, ' ', "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://policies.google.com/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"), ' ', "apply."), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Privacy policy",
    buttonType: _constants.BUTTON_TYPES.BARE_PRIMARY,
    icon: "arrow-right",
    iconFlip: true,
    fullWidth: true,
    link: "/legal",
    buttonSize: "btn--md"
  }), _global["default"].grecaptcha ? /*#__PURE__*/_react["default"].createElement(_reactRecaptchaGoogle.ReCaptcha, {
    ref: contactFormCaptcha,
    size: "invisible",
    render: "explicit",
    sitekey: "6LcgJrIZAAAAAN-XXg4b6OebJIGVyMNEAj-sH9WS",
    onloadCallback: onLoadRecaptcha,
    verifyCallback: verifyCallback
  }) : null));
};
var _default = exports["default"] = TswContactUs;